import * as React from 'react';
import type {
  ActionEvent,
  PreviewCardWidgetPayload,
} from 'src/components/agentic-ui/types';

import {PreviewCard} from '@spaced-out/ui-design-system';


export type PreviewCardWidgetProps = {
  data: PreviewCardWidgetPayload;
  publishMessageAction?: (action: ActionEvent) => void;
};

export const PreviewCardWidget = ({
  data,
  publishMessageAction,
}: PreviewCardWidgetProps) => {
  const {title, event, iconName, previewText} = data;
  const {product, name, payload} = event;

  return (
    <PreviewCard
      title={title}
      onClick={() => publishMessageAction?.({product, event: name, payload})}
      isSelected={false}
      previewText={previewText}
      cardImgIconName={iconName}
    />
  );
};
